import { render } from "./Stages.vue?vue&type=template&id=6acff754&scoped=true"
import script from "./Stages.vue?vue&type=script&lang=js"
export * from "./Stages.vue?vue&type=script&lang=js"

import "./Stages.vue?vue&type=style&index=0&id=6acff754&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acff754"]])

export default __exports__